import { useDispatch, useSelector } from 'react-redux';
import {
  submitLogin,
  submitGoogleAuth,
  fetchLogin,
  fetchUser,
  clearUser,
  preLogin,
  submitLoginSSO,
} from '../../ducks/loginActions';

const useLogin = () => {
  const isLoginLoading = useSelector((state) => state.auth.ui.isLoginLoading);
  const isSSOLoginLoading = useSelector((state) => state.auth.ui.isSSOLoginLoading);
  const isAuthenticated = useSelector((state) => state.auth.ui.isAuthenticated);
  const loginError = useSelector((state) => state.auth.ui.loginError);
  const googleError = useSelector((state) => state.auth.ui.googleError);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const ssoLoginError = useSelector((state) => state.auth.ui.ssoLoginError);

  const dispatch = useDispatch();

  const handleLogin = (values) => {
    dispatch(submitLogin(values));
  };

  const handleLoginSSO = (values, registrationEnabled) => {
    dispatch(submitLoginSSO(values, registrationEnabled));
  };

  const handlePreLogin = (email, registrationEnabled) => {
    dispatch(preLogin(email, registrationEnabled));
  };

  const handleGoogleAuth = (values) => {
    dispatch(submitGoogleAuth(values));
  };

  const handleFetchUser = () => {
    dispatch(fetchLogin());
  };

  const handleFetchMe = () => {
    dispatch(fetchUser());
  };

  const clearCurrentUser = () => {
    dispatch(clearUser());
  };

  return {
    clearCurrentUser,
    currentUser,
    isSSOLoginLoading,
    handleGoogleAuth,
    handleLogin,
    handleFetchUser,
    handleFetchMe,
    googleError,
    isLoginLoading,
    isAuthenticated,
    loginError,
    ssoLoginError,
    handlePreLogin,
    handleLoginSSO,
  };
};

export default useLogin;
